import request from './api'

export class CalendarService {
    async getCalendarEvents() {
        const response = await request({
            method: 'GET',
            url: `api/fixtures/calendar`
        });

        return response;

    }

    async getFixtureDetails(bureauMatchId: number, fixtureRoomId: string | null) {
        const response = await request({
            method: 'GET',
            url: `api/fixtures/${bureauMatchId}/details${fixtureRoomId ? `?fixtureRoomId=${fixtureRoomId}` : ''}`,
        });

        return response;
    }

    async getAssignUsersList() {
        const response = await request({
            method: 'GET',
            url: `api/fixtures/users/assign-list`
        });

        return response;
    }

    async assignUser(fixtureRoomId: string, userId: string) {
        const response = await request({
            method: 'POST',
            url: `api/fixtures/${fixtureRoomId}/assign`,
            data: {
                userId
            }
        });

        return response;
    }

    async unassignUser(fixtureRoomId: string, userId: string) {
        const response = await request({
            method: 'POST',
            url: `api/fixtures/${fixtureRoomId}/unassign`,
            data: {
                userId
            }
        });

        return response;
    }

    async deleteFixtureRoom(fixtureRoomId: string) {
        const response = await request({
            method: 'DELETE',
            url: `api/fixtures/${fixtureRoomId}/delete`,
            data: {}
        });

        return response;
    }

    async updateFixtureLevel(fixtureId: string, level: any) {
        const response = await request({
            method: 'POST',
            url: `api/fixtures/${fixtureId}/level`,
            data: {level}
        });

        return response;
    }

    static get instance() {
        return calendarService
    }
}

const calendarService = new CalendarService();

export default calendarService;